import React, { useState, useEffect, Children } from "react";
import { AttendanceVM, QualityVM } from "../../Models/ViewModels";
import {
  Table,
  Pagination,
  Stack,
  Avatar,
  Input,
  Button,
  DatePicker,
} from "rsuite";
import * as ProfileDB from "../../Services/KRAApprovalDB";
import { PageHeader } from "../../SharedComponents/PageHeader";

import { handleDownloadAsExcel } from "../../Helpers/Utils";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { CustomTableCell } from "../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../SharedComponents/CustomTableHeaderCell";
import { BootstrapIcon } from "../../SharedComponents/BootstrapIcon";

const { Column, HeaderCell, Cell } = Table;
const colors = ["pink", "grey", "blue", "yellow", "purple", "green", "red"];

export const AttendanceReport = () => {
  const [cachedEmployeesList, setCachedEmployeesList] = useState(
    new Array<AttendanceVM>()
  );
  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true);
  const [sortType, setSortType] = useState();
  const [page, setPage] = React.useState(1);
  const [date, setDate] = useState();

  const [limit, setLimit] = React.useState(10);
  const [filteredEmployeesList, setFilteredEmployeesList] = useState(
    new Array<AttendanceVM>()
  );
  const [loginid, setLoginid] = useState(GetUserLoginID());
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    getEmployeesAttendanceReport(loginid);
  }, []);

  const handleSetDate = (e: any) => {
    var value = e.target.value;
    handleSet(value);
  };
  const handleSet = (value: any) => {
    setDate(value);
    var resultfilteredData = cachedEmployeesList.filter((a) => {
      var date = a.AttendanceMonth.substring(0, 7);
      return date == value;
    });
    setFilteredEmployeesList(resultfilteredData);
  };
  const tableDataFeed = filteredEmployeesList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const getEmployeesAttendanceReport = (loginid: any) => {
    ProfileDB.GetAttendanceReport(loginid)
      .then((res) => {
        if (res.data) {
          setCachedEmployeesList(res.data);
          setFilteredEmployeesList(res.data);
          setDate(res.data[0].AttendanceMonth.substring(0, 7));
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("fail");
      });
  };

  const handleFilterData = (val: string, e: any) => {
    let searchText = val;

    setPage(1);
    if (searchText) {
      setFilteredEmployeesList(
        cachedEmployeesList.filter((e) =>
          JSON.stringify(e).toLowerCase().includes(searchText.toLowerCase())
        )
      );
    } else {
      setFilteredEmployeesList([...cachedEmployeesList]);
    }
  };

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);

    if (sortColumn && sortType) {
      return filteredEmployeesList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-7">
          <PageHeader title="Attendance Report" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-2">
          <Input
            className="form-control w-100 border border-dark"
            placeholder="Search..."
            type={"search"}
            id="search"
            onChange={handleFilterData}
          />{" "}
        </div>
        <div className="col-md-2">
          <input
            type="month"
            className="form-control"
            id="inputtype"
            value={date}
            onChange={handleSetDate}
          />
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={30}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(filteredEmployeesList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={33}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}{" "}
        </div>
        <div className="col"></div>
        <hr />
      </div>

      <div className="show-container" bg-color="pink">
        <Table
          id="table"
          data={tableDataFeed}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column align="center" width={100} fixed sortable>
            <CustomTableHeaderCell placement={"Year-Month"}>
              Year-Month
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="AttendanceMonth" />
          </Column>
          <Column align="center" width={100} sortable>
            <CustomTableHeaderCell placement={"Employee ID"}>
              Employee ID
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="EmployeeID" />
          </Column>

          <Column align="center" width={190} sortable>
            <CustomTableHeaderCell placement={" Employee Name"}>
              Employee Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="EmployeeName" />
          </Column>
          <Column width={160} align="center">
            <CustomTableHeaderCell placement={"Base Attendance"}>
              Base Attendance
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="BaseAttendance" />
          </Column>
          <Column width={160} align="center">
            <CustomTableHeaderCell placement={"Eligible Attendance"}>
              Eligible Attendance
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="EligibleAttendance" />
          </Column>
          <Column width={160} align="center">
            <CustomTableHeaderCell placement={"Total Weekly Off"}>
              Total Weekly Off
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="TotalWeeklyOff" />
          </Column>
          <Column width={160} align="center" sortable>
            <CustomTableHeaderCell placement={"Approved Leave Days"}>
              Approved Leave Days
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ApprovedLeaveDays" />
          </Column>
          <Column width={160} align="center" sortable>
            <CustomTableHeaderCell placement={"LOP"}>LOP</CustomTableHeaderCell>
            <CustomTableCell dataKey="LOP" />
          </Column>

          <Column width={160} align="center" sortable>
            <CustomTableHeaderCell placement={"Full Present"}>
              Full Present
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="FullPresent" />
          </Column>

          <Column width={150} align="center">
            <CustomTableHeaderCell placement={" Total Paid Days"}>
              Total Paid Days
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="TotalPaidDays" />
          </Column>
        </Table>

        {filteredEmployeesList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredEmployeesList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
